import React from 'react';
import Days from './MonthView/Days';
import Weekdays from './MonthView/Weekdays';
import WeekNumbers from './MonthView/WeekNumbers';
import { cn } from '@fshr/shared-react';

type MonthViewProps = {
	showWeekNumbers?: boolean;
	isMobile?: boolean;
	baseClassName?: string;
} & React.ComponentProps<typeof Weekdays> &
	React.ComponentProps<typeof WeekNumbers> &
	React.ComponentProps<typeof Days>;

const MonthView: React.FC<MonthViewProps> = function MonthView(props) {
	const { activeStartDate, locale, showFixedNumberOfWeeks, isMobile, baseClassName } = props;
	const { formatShortWeekday, formatWeekday, onClickWeekNumber, showWeekNumbers, ...childProps } =
		props;

	function renderWeekdays() {
		if (isMobile) {
			return null;
		}
		return (
			<Weekdays
				formatShortWeekday={formatShortWeekday}
				formatWeekday={formatWeekday}
				locale={locale}
			/>
		);
	}

	function renderWeekNumbers() {
		if (!showWeekNumbers) {
			return null;
		}

		return (
			<WeekNumbers
				activeStartDate={activeStartDate}
				onClickWeekNumber={onClickWeekNumber}
				showFixedNumberOfWeeks={showFixedNumberOfWeeks}
				baseClassName={baseClassName}
			/>
		);
	}

	function renderDays() {
		const props = { ...childProps };
		return <Days {...props} baseClassName={baseClassName} isMobile={isMobile} />;
	}

	const className = `${baseClassName}__month-view`;

	return (
		<div
			className={cn(className, 'w-full', {
				[`${className}--weekNumbers`]: showWeekNumbers,
			})}
		>
			<div
				style={{
					display: 'flex',
					alignItems: 'flex-end',
				}}
			>
				{renderWeekNumbers()}
				<div
					style={{
						flexGrow: 1,
						width: '100%',
					}}
				>
					{renderWeekdays()}
					{renderDays()}
				</div>
			</div>
		</div>
	);
};

export default MonthView;
